import { render, staticRenderFns } from "./EditorDrawer.vue?vue&type=template&id=276591d4&scoped=true&"
import script from "./EditorDrawer.vue?vue&type=script&lang=ts&"
export * from "./EditorDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./EditorDrawer.vue?vue&type=style&index=0&id=276591d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276591d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VIcon,VNavigationDrawer})
